"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingStarGradeSizes = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_id_generator_1 = tslib_1.__importDefault(require("react-id-generator"));

var getRatingType_1 = tslib_1.__importDefault(require("../../utils/getRatingType"));

var Icon_1 = tslib_1.__importDefault(require("../Icon"));

var styles = tslib_1.__importStar(require("./RatingStarGrade.style"));

var Star_1 = tslib_1.__importDefault(require("./Star"));

exports.RatingStarGradeSizes = ['medium', 'small'];

function RatingStarGrade(_ref) {
  var className = _ref.className,
      size = _ref.size,
      rating = _ref.rating,
      reviewCount = _ref.reviewCount,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? 'ic_arrow_right_12x12_gray_500' : _ref$icon,
      onClick = _ref.onClick;
  var ratings = Array(size === 'medium' ? 5 : 1).fill(0);

  function handleOnClick() {
    onClick && onClick();
  }

  return jsx_runtime_1.jsxs("div", Object.assign({
    className: className,
    css: styles.container(size),
    onClick: handleOnClick
  }, {
    children: [jsx_runtime_1.jsx("span", Object.assign({
      css: styles.stars
    }, {
      children: ratings.map(function (_notUsedValue, index) {
        return jsx_runtime_1.jsx(Star_1.default, {
          filled: getRatingType_1.default(rating, index)
        }, react_id_generator_1.default());
      })
    }), void 0), jsx_runtime_1.jsx("span", Object.assign({
      css: styles.rating
    }, {
      children: rating.toFixed(1)
    }), void 0), jsx_runtime_1.jsx("span", Object.assign({
      css: styles.reviewCount
    }, {
      children: "(".concat(reviewCount, ")")
    }), void 0), size === 'medium' && jsx_runtime_1.jsx(Icon_1.default, {
      name: icon
    }, void 0)]
  }), void 0);
}

exports.default = react_1.memo(RatingStarGrade);